import React, { useEffect, useState } from "react";
import firebase, { auth } from "../utils/firebase";
import { onAuthStateChanged, signOut, getAuth } from "@firebase/auth";
import { analytics } from "../utils/firebase.js";
import { logEvent } from "@firebase/analytics";

export const AuthContext = React.createContext();

export const handleLogout = (user) => {
    const auth = getAuth();

    signOut(auth)
      .then(() => {
        logEvent(analytics, 'LOG_OUT: ' + user.email)
        // Redirect to login page or do something else after logout
        window.location.href = "/login";
      })
      .catch((error) => {
        // Handle errors here
        console.error('Error signing out:', error);
      });
  };

export const AuthProvider = ({ children }) => {
    const [currentUser, setCurrentUser] = useState(null);
    const [pending, setPending] = useState(true);

    const updateUser = (user) => {
        console.log("UPDATING user", user);
        setCurrentUser(user);
    }

    useEffect(() => {
        onAuthStateChanged(auth, (user) => {
            setCurrentUser(user)
            setPending(false)
        });
    }, []);

    if (pending) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', background: '#1a1a2e' }}>
                <div style={{ width: 40, height: 40, border: '3px solid rgba(255,255,255,0.1)', borderTopColor: '#fff', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} />
                <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
            </div>
        );
    }

    return (
        <AuthContext.Provider
            value={{
                currentUser,
                pending, 
                updateUser
            }}
        >
            {children}
        </AuthContext.Provider>
    );
};